import { Link } from "@bond-london/gatsby-plugin-cms-i18next";
import { IGatsbySvg } from "@bond-london/gatsby-transformer-extracted-svg";
import React from "react";

export const PageLogo: React.FC<{
  logo?: IGatsbySvg;
}> = ({ logo }) => {
  return (
    <section
      data-component="Page Logo"
      className="page-grid absolute top-0 z-40 mt-30px w-full"
    >
      {logo && (
        <Link to="/" className="col-span-3 col-start-2">
          <img
            src={logo.encoded ?? logo.encodedUrl}
            alt="Logo"
            className="h-[60px]"
            width="218.94px"
            height="60px"
          />
        </Link>
      )}
    </section>
  );
};
